export default __webpack_public_path__ + "static/media/catalin-dorgo.0ac702dc.png";